import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import type { Swiper as SwiperType } from 'swiper';
import 'swiper/css';

import './ImageSwiper.scss';

interface Props { urls: string[] }

const ImageSwiper: React.FC<Props> = ({ urls }) => {
  const [activeIdx, setActiveIdx] = useState(0);

  const onSlideChange = (swiper: SwiperType) => setActiveIdx(swiper.realIndex);

  return (
    <div className="img-swiper">
      <Swiper
        slidesPerView={1}
        spaceBetween={8}
        onSlideChange={onSlideChange}
      >
        {urls.map((u, i) => (
          <SwiperSlide key={i}>
            <img src={u} alt={`preview-${i}`} />
          </SwiperSlide>
        ))}

      </Swiper>
        <div className="indicator" style={{height: 10}}>
            {urls.map((_, i) => (
            <span key={i} className={i === activeIdx ? 'dash active' : 'dash'}></span>
            ))}
        </div>


    </div>
  );
};

export default ImageSwiper;

